import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { GREY_COLOR } from '~/constants/colors';
export default makeStyles((theme: Theme) =>
    createStyles({
        title: {
            marginBottom: 24,
        },
        text: {
            marginBottom: 16,
            color: GREY_COLOR.TextGrey,
        },
        subtitle: {},
        section: {
            marginTop: 24,
        },
        list: {
            marginBottom: 32,
        },
        listItem: {
            color: GREY_COLOR.TextGrey,
            marginBottom: 8,
        },
        mainContainer: {
            paddingTop: 24,
        },
    })
);
